import React, { useState } from "react";
import "./Contact.css";
import db from "../../firebase";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const send = (e) => {
    e.preventDefault();

    db.collection("feedback").add({
      name: name,
      email: email,
      message: message,
    });

    setName("");
    setEmail("");
    setMessage("");
    window.alert("Your feedback has been sent, Thank You.");
  };

  return (
    <div className="contact" id="contact">
      {/* <h2>Contact</h2> */}
      <div className="contact_form">
        <form>
          <input
            placeholder="Enter Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
          />
          <input
            placeholder="Enter Your E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />
          <textarea
            style={{ overflow: "hidden" }}
            className="contact_form_message"
            placeholder="Enter Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            type="text"
          />
        </form>
        <button onClick={send}>Send </button>
      </div>
    </div>
  );
}

export default Contact;
